import React, { useState, useEffect, useContext, useRef} from 'react';
import {IProps, IState} from './types';
import selectors from '@state/selectors';
import Button from '@components/Button';
import * as S from './styles';
import C from '@assets/themes/colors';
import { useDispatch, useSelector } from 'react-redux';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { sendFile, copyFile } from '@utils/cloudStorage';
import { IElementUpdate , IActionInfo} from '../../../../../../state/brands/types';
import { IBrandImage } from '../../../../../../state/brandsImages/types';
import { storageAccountName, containerNameBrands } from '@storage/azure-storage-blob';
import { imageFileTypes, fontFileTypes } from '@utils/brand';
import { ArrowLongIcon } from '@assets/icons/arrowLongIcon';
import { Font } from '../AddElement/styles';
import { getArrayBuffer } from '@utils/userUtils';
import { loadFont } from '@utils/fonts';
import { resizeImage, reduceImageFileSize, getBase64 } from 'utils/images'
import { IDSConfig } from '@state/dsconfig/types';

const ReplaceItem:React.FC<IProps> = (props) => {
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const authContext = useContext(AuthContext);
  const { brandAction, brandDetail, addUpdateBrand, setBrandAction, movefile} = useContext(BrandsContext);
  const element = brandAction.element;
  const isFontSection = brandAction.section === "fonts";
  const urlImage =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}/${brandDetail?.brand?.id}/${brandAction.section}/`;

  const [reloadImage, setReloadImage] = useState<any>(Date.now());
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [filesUploaded, setFilesUploaded] = useState<IState['files']|undefined>(undefined);
  const [newFont, setNewFont] = useState('');
  let fileInputRef = useRef<HTMLInputElement>(null);

  const moveFileResponse = useSelector(selectors.brands.getMoveFileResponse);

  const dispatch = useDispatch();

  useEffect(() => {
    if (moveFileResponse?.status >= 200 && moveFileResponse?.status <= 300) sendUploadingFiles();
}, [moveFileResponse])

  const handleUploadFile = () => {
    if (fileInputRef.current) (fileInputRef.current as any).click();
  }

  const onInputFileChange = (e: any) => {
    if (fileInputRef.current) {
      validateFiles((fileInputRef.current as any).files);
    }
    e.target.value = '';
  }

  const validateFiles = (files: File[]) => {
    let errorFiles: string[] = [];
    let newFiles: File[] = [];
    for(let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileTypes = isFontSection ? fontFileTypes : imageFileTypes;
      if (fileTypes.includes(file.type) || isFontSection) newFiles = [...newFiles, file];
      else errorFiles = [...errorFiles, file.name];
    }
    /*if (errorFiles.length > 0) {
      context.onWarningScreenChange(
        true, "Upload File Error",
        `The available image types are: jpeg, png and svg.`,
        "", undefined, "OKAY", "Invalid File Type", errorFiles
      );
    }*/
    
    if (newFiles[0]) {
      setFilesUploaded(newFiles[0]);
      if (isFontSection) sendFont(`font-${element.id}-tmp`, newFiles[0]);
    }
  }

  const sendFileResponse = async (name: string, data: string) => {
    try {
      await sendFile(name, data, dispatch, undefined, "brands");
      updateBrand();
    } catch(e) {   
      console.error(e);
    }
  }

  const sendFont = async (id: string, file: File) => {
    let arrayBuffer = await getArrayBuffer(file);
    if (arrayBuffer) {
      loadFont(id, arrayBuffer);
      setNewFont(id);
    }
  }

  const sendUploadingFiles = async()=>
  { 
    if (filesUploaded) {
      let folder = brandDetail.brand.id;
      let id = element.id;
      let srcFile: any = await getBase64(filesUploaded)
      if (isFontSection) {
        sendFont(id, filesUploaded);
        const ext = filesUploaded.name.split(".").slice(-1)[0];
        sendFileResponse(`${folder}/${brandAction.section}/${id}.${ext}`, srcFile);
      } else {
        let format = (filesUploaded.name.toLocaleLowerCase().indexOf(".jpg")!==-1?"JPEG":"PNG");
        let imageThumbnailBase64 = undefined;
        if (dsConfig.clientImageProcessing && dsConfig.clientImageProcessing.thumbnailDefinition) {
          imageThumbnailBase64 = (await resizeImage(filesUploaded, format, dsConfig.clientImageProcessing.thumbnailDefinition.width, dsConfig.clientImageProcessing.thumbnailDefinition.height, true)).toString();
          if (imageThumbnailBase64) sendFileResponse(`${folder}/${brandAction.section}/${id}` + "TN", imageThumbnailBase64);
        }
        let imageCompressedBase64 = srcFile;
        if (dsConfig.clientImageProcessing && dsConfig.clientImageProcessing.imageMaxFileSize && dsConfig.clientImageProcessing.pixelResize) {
          imageCompressedBase64 = ((await reduceImageFileSize(filesUploaded, format, (dsConfig.clientImageProcessing.imageMaxFileSize * 1024),dsConfig.clientImageProcessing.pixelResize))??"").toString();
        }
        if (imageCompressedBase64) sendFileResponse(`${folder}/${brandAction.section}/${id}`, imageCompressedBase64);
      }
    }      
  }

  const updateBrand = () => { 
    const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };

    let elementUpdate: any = {...brandAction.element}; 
    let splitPath = moveFileResponse.data.split('/');
    let newFile: string = "";
    if (splitPath[2]) newFile= splitPath[2];

    let newActionDelete : IActionInfo = {
      user: userData,
      date: new Date(),
      action:"REPLACE",
      fileBackup: newFile.split('.')[0]
    }
    elementUpdate.actions.push(newActionDelete);

    if (filesUploaded) {
      const splittedName = filesUploaded.name.split(".");
      const name = splittedName.slice(0, -1).join(".");
      const ext = splittedName.slice(-1)[0];
      elementUpdate.format = ext.toUpperCase();
      elementUpdate.name = name;
      if (isFontSection) elementUpdate.ext = ext;
    }

    let updateInfoOld : IElementUpdate = {
      action: "UPDATE", //INSERT DELETE UPDATE
      field: brandAction.section.toUpperCase(),
      value: elementUpdate
    }
    addUpdateBrand([updateInfoOld]);
  }

  const handleReplace = () => {
    if(element) { 
      setIsSaving(true);
      movefile(element.srcImage);
    }
  }
  
  const elementNameSplitted = props.elementName.split(' ');
  
  return (
    <S.Root style={{
      display: props.open ? 'flex' : 'none',
    }} >
      <S.BoxContainer>
        <S.TitleContainer>
          <S.LeftSide>
            <S.Title>
            Replace {elementNameSplitted[1] ?? elementNameSplitted[0]}
            </S.Title>
          </S.LeftSide>
        </S.TitleContainer>
        <S.Content>
            <S.Description>
            If you replace this {props.elementName.toLocaleLowerCase()}, {element?.templatesCount ?? 0} templates and {element?.designsCount ?? 0} design files will reflect this change. The metadata will remain the same for the replacement. 
            </S.Description>
            <S.LoadContainer
              isFontSection={isFontSection}
            >
              <S.Container style={{marginRight: '51px'}}>
                <S.Label>Replace with</S.Label>
                <input 
                  ref={fileInputRef} 
                  id="fileInput" 
                  type="file" 
                  style={{display: "none"}} 
                  onChange={onInputFileChange} 
                  accept={isFontSection ? fontFileTypes.join() : imageFileTypes.join()} 
                  multiple={true}
                />
                <Button icon="add" label={`UPLOAD ${(elementNameSplitted[1] ?? elementNameSplitted[0]).toUpperCase()}`}
                  style={{hoverBackgroundColor: C.BLUE, backgroundColor: "#19325d", width: 128, height: 16, borderRadius: '5px',  marginRight: '0px', padding: "none"}}
                  iconStyle={{fillColor: C.WHITE, width: 15, height: 15}}
                  onClick={()=>handleUploadFile()}
                />
              </S.Container>
              
              {filesUploaded && 
              <S.Container 
                style={{display: isFontSection ? 'flex' : 'inline-flex'}}
                isFontSection={isFontSection}
              >
                {
                  isFontSection ? 
                    <Font fontFamilyValue={`font-${brandAction.element.id}`} >
                      {brandAction.element.name}
                    </Font>
                  :
                    <S.Images>
                      <S.ImgContainer height={90} src={`${urlImage}${element.srcImage}${"TN"}?${reloadImage}`}/>
                      <S.TextInfo>{`${element.name}.${element.format}`}</S.TextInfo>
                    </S.Images>
                }
                <S.Replace>
                  <ArrowLongIcon/>
                  <S.TextCenter>Replaced with</S.TextCenter>
                </S.Replace>
                {
                  isFontSection ? 
                    <Font fontFamilyValue={newFont} >
                      {filesUploaded?.name?.split(".").slice(0, -1).join(".")}
                    </Font>
                  :
                    <S.Images>
                      <S.ImgContainer height={90} src={URL.createObjectURL(filesUploaded)}/>
                      <S.TextInfo>{filesUploaded.name}</S.TextInfo>
                    </S.Images>
                }
              </S.Container>}
            </S.LoadContainer>
        </S.Content>
        <S.ActionsContainer>
          <S.Action>
            <Button
              label="CANCEL"
              style={{
                width: '112px',
                marginRight: 12, 
                backgroundColor: "transparent", 
                border: `1px solid ${C.BLUE}`, 
                hoverBackgroundColor: `${C.BLUE}22`,
              }}
              labelStyle={{color: C.BLUE}}
              onClick={() => setBrandAction(undefined)}
              disabled={isSaving ? true : false}
            />
          </S.Action>
          <S.Action>
            <Button
              label={isSaving ? "SAVING..." : "REPLACE"}
              style={{
                width: '112px',
                backgroundColor: filesUploaded ? C.BLUE  : C.GENERIC_GRAY , 
                flexGrow: 0, 
                hoverBackgroundColor: filesUploaded ?  `${C.BLUE}AA` : `${C.GENERIC_GRAY}AA`,
              }} 
              onClick={()=>{if (filesUploaded) handleReplace();}}
              disabled={isSaving ? true : filesUploaded ?  false : true}
            />
          </S.Action>
        </S.ActionsContainer>
      </S.BoxContainer>
    </S.Root>
  );
}

export default ReplaceItem;